/** @jsxImportSource @emotion/react */
import { useEffect, useState,useContext } from 'react';
import classes from './style';
import UploadInput from '../UploadInput';
import CloseIcon from '@mui/icons-material/Close';
import axios from '../../../Helper/Axios/interceptor';
import { Grid, DialogTitle, DialogContent, Tooltip, IconButton, CircularProgress, Dialog } from '@mui/material';
import { Il8nContext } from '../../../Helper/i18n';


function ProofDialog(props) {
  const { onFile, data, getDocumentTypeURL, dialogTitle, handleClose, isLivePhotoCapture, accept, handleLivePhotoCapture, open, setSnackBar, setSelectedDocumentMasterData, limitPdfPages } = props;

  const [active, setActive] = useState(0)
  const [documentMaster, setDocumentMaster] = useState("Loading...")
  const localeText = useContext(Il8nContext)

  useEffect(() => {
    if (data) {
      setDocumentMaster("Loading...")
      axios.get(`${process.env.REACT_APP_API_URL}${getDocumentTypeURL}`, { docTypeCode: data }).then(response => {
        if (response?.data?.success?.documentsReq?.length > 0) {
          setDocumentMaster(response.data.success.documentsReq)
        } else {
          setDocumentMaster(response.data.error || localeText?.uploadFound)
        }
      }).catch(exception => {
        setDocumentMaster(exception.message || localeText?.uploadFound)
      })
    }
  }, [data])

  function updateActiveGrid(document, index) {
    setActive(index);
    setSelectedDocumentMasterData(document)
  }

  const content = () => {
    return (
      <Grid container spacing={2}>
        {
          typeof (documentMaster) === "string" ?
            <Grid item xs={12} style={{ display: 'flex', margin: 'auto', justifyContent: 'center', height: '80px' }}>
              {
                documentMaster === "Loading..." ?
                  <CircularProgress size={50} style={{ color: '#00000042' }} />
                  :
                  <div style={{ textAlign: "center", width: "100%" }}>{documentMaster}</div>
              }
            </Grid>
            :
            documentMaster?.length > 0 ?
              documentMaster.map((doc, i) => (
                <Grid item xs={6} md={4} key={i} style={classes.center} onClick={() => updateActiveGrid(doc, i)}>
                  {
                    <Grid container spacing={2}>
                      <Grid item md={2}>
                      </Grid>
                      <Grid item md={8} xs={12} sm={12} style={{ cursor: "pointer" }}>
                        <UploadInput
                          index={i}
                          active={active}
                          onFile={onFile}
                          documentData={doc}
                          setSnackBar={setSnackBar}
                          accept={accept || doc.documentFormat}
                          image={"images/uploadIcon.svg"}
                          activeImage={"images/upload_icon_active.svg"}
                          handleLivePhotoCapture={handleLivePhotoCapture}
                          boxStyle={active === i ? classes.active : classes.uploadWrapper}
                          isLivePhotoCapture={isLivePhotoCapture && doc.documentTypeName === "Photograph & Signature"}
                          limitPdfPages={limitPdfPages}
                        />
                      </Grid>
                      <Grid item md={2}>
                      </Grid>
                    </Grid>
                  }
                </Grid>
              ))
              :
              <></>
        }
      </Grid>
    )
  }

  return (
    <Dialog fullWidth maxWidth='sm' open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          handleClose(event, reason);
        }
      }}
    >
      <DialogTitle>
        <Grid container>
          <Grid item sm={10} xs={10} style={classes.title}>
            {dialogTitle || ''}
          </Grid>
          <Grid item sm={2} xs={2} style={{ textAlign: "right" }}>
            <Tooltip title="Close" aria-label="close">
              <IconButton aria-label="close" onClick={handleClose} size="large">
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        {content()}
      </DialogContent>
    </Dialog>
  )
}

export default ProofDialog;